export const queryKeyNamespaces = {
  user: 'user',
  font: 'font',
  cover: 'cover',
  letter: 'letter',
};
